<template>
    <div class="main-box">
        <!-- 客户档案 -->
        <div class="main-title mb-40">
            <div class="black font34 bold">客户档案</div>
        </div>
        <div class="main-archives flex flex-between mb-50">
            <div class="archives-item flex flex-col flex-y-center" @click="toRemainDetail(REMAIN_DETAIL_TAB.CARD)">
                <img class="item-icon mb-10" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/card.png"
                    alt="" />
                <div class="black font36 mb-10 bold">{{ customerRecord.cards }}</div>
                <div class="gray font26">卡余明细</div>
            </div>
            <div class="archives-item flex flex-col flex-y-center" @click="toRemainDetail(REMAIN_DETAIL_TAB.COURT)">
                <img class="item-icon mb-10" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/line.png"
                    alt="" />
                <div class="black font36 mb-10 bold">{{ customerRecord.storages }}</div>
                <div class="gray font26">院余明细</div>
            </div>
            <div class="archives-item flex flex-col flex-y-center" @click="toRemainDetail(REMAIN_DETAIL_TAB.TICKET)">
                <img class="item-icon mb-10" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/quan.png"
                    alt="" />
                <div class="black font36 mb-10 bold">{{ customerRecord.coupons }}</div>
                <div class="gray font26">券余明细</div>
            </div>
            <div class="archives-item flex flex-col flex-y-center" @click="toRemainDetail(REMAIN_DETAIL_TAB.CONSUME)">
                <img class="item-icon mb-10" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/money.png"
                    alt="" />
                <div class="black font36 mb-10 bold">{{ customerRecord.consume }}</div>
                <div class="gray font26">消费明细</div>
            </div>
        </div>
        <!-- 客户消费 -->
        <div class="main-title mb-40">
            <div class="black font34 bold">客户消费</div>
        </div>
        <div class="main-consume flex mb-50">
            <div class="consume-item flex flex-col flex-x-center">
                <div class="black font34 mb-10 bold">{{ customerConsume.rechargeMoneySM }}</div>
                <div class="gray font24">R12生美充值金额</div>
            </div>
            <div class="consume-item flex flex-col flex-x-center">
                <div class="black font34 mb-10 bold">{{ customerConsume.sellMoneySM }}</div>
                <div class="gray font24">R12生美销售金额</div>
            </div>
            <div class="consume-item flex flex-col flex-x-center">
                <div class="black font34 mb-10 bold">{{ customerConsume.consumeMoneySM }}</div>
                <div class="gray font24">R12生美消费金额</div>
            </div>
            <div class="consume-item flex flex-col flex-x-center">
                <div class="black font34 mb-10 bold">{{ customerConsume.storeNumberSM }}</div>
                <div class="gray font24">R12生美来店次数</div>
            </div>
            <div class="consume-item flex flex-col flex-x-center">
                <div class="black font34 mb-10 bold">{{ customerConsume.rechargeMoneyYM }}</div>
                <div class="gray font24">R12医美销售金额</div>
            </div>
            <div class="consume-item flex flex-col flex-x-center">
                <div class="black font34 mb-10 bold">{{ customerConsume.rechargeMoneyKS }}</div>
                <div class="gray font24">R12抗衰销售金额</div>
            </div>
        </div>
    </div>
</template>

<script>
import { REMAIN_DETAIL_TAB } from './config'
export default {
    props: {
        custId: String,
        customerRecord: {
            type: Object,
            default: function () {
                return {};
            },
        },
        customerConsume: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    data() {
        return { REMAIN_DETAIL_TAB };
    },
    mounted() { },
    methods: {
        toRemainDetail(tabName) {
            if (!this.custId) return
            this.$router.push({ name: "remainDetail", query: { custId: this.custId, tabName ,accountNo:this.$route.query.accountNo} });
        },
    },
};
</script>
<style scoped>
.mr-10 {
    margin-right: 10px;
}
.D5F3F8 {
    color: #d5f3f8;
}
.black {
    color: #35434c;
}
.gray {
    color: #a0acb5;
}

/* ----- */
.main-box {
    width: 100%;
    height: 100%;
    background-color: #fff;
    /* padding: 0 30px 50px 30px; */
    margin-top: 40px;
}
.main-title {
    justify-content: flex-start;
}
.main-title-more {
    display: flex;
    justify-content: space-around;
}
.main-title .icon {
    width: 40px;
    height: 40px;
}
.main-archives {
    width: 690px;
    height: 227px;
    background: #ffffff;
    box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
    border-radius: 30px;
    padding: 40px 40px;
    box-sizing: border-box;
}
.archives-item .item-icon {
    width: 46px;
    height: 46px;
}
.main-consume {
    width: 690px;
    background: #ffffff;
    box-sizing: border-box;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
}
.consume-item {
    width: 330px;
    height: 131px;
    margin-bottom: 20px;
    background: #fafafe;
    border-radius: 12px;
    text-align: left;
    padding: 20px 50px;
    box-sizing: border-box;
}
.consume-item .item-icon {
    width: 46px;
    height: 46px;
}
.main-title-more .title-box {
    width: 70%;
}
.main-title-more .more {
    width: 25%;
}
.main-diary {
    width: 690px;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
    border-radius: 30px;
    padding: 40px 30px;
}
.diary-title {
    width: 100%;
    height: 46px;
    line-height: 46px;
}
.diary-title .diary-icon {
    width: 34px;
    height: 34px;
}
.diary-title .diary-btn {
    height: 46px;
    padding: 0 14px;
    background: #ff8519;
    border-radius: 23px;
    color: #fff;
    line-height: 46px;
    margin-right: 30px;
}
.diary-line {
    margin-top: 30px;
    width: 100%;
    font-size: 28px;
    color: #35434c;
}
</style>
